import algoliasearch from 'algoliasearch';

import { createSearchBase, excludedPartnersSearch } from '@packages/services';
import { AlgoliaIndiceName, isBrowser } from '@packages/common';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

const ALGOLIA_APPLICATION_ID_1 = getPublicRuntimeConfig('ALGOLIA_APPLICATION_ID_1');
const ALGOLIA_APPLICATION_ID_2 = getPublicRuntimeConfig('ALGOLIA_APPLICATION_ID_2');
const ALGOLIA_SEARCH_API_KEY_1 = getPublicRuntimeConfig('ALGOLIA_SEARCH_API_KEY_1');
const ALGOLIA_SEARCH_API_KEY_2 = getPublicRuntimeConfig('ALGOLIA_SEARCH_API_KEY_2');

const hasSplitAlgoliaClient = ALGOLIA_APPLICATION_ID_2 && ALGOLIA_SEARCH_API_KEY_2;

const algoliaClient1 = algoliasearch(ALGOLIA_APPLICATION_ID_1, ALGOLIA_SEARCH_API_KEY_1, {});
const algoliaClient2 = hasSplitAlgoliaClient
  ? algoliasearch(ALGOLIA_APPLICATION_ID_2, ALGOLIA_SEARCH_API_KEY_2, {})
  : algoliaClient1;

if (!isBrowser()) {
  if (!hasSplitAlgoliaClient) {
    console.log(`Starting with single algolia application ${ALGOLIA_APPLICATION_ID_1}`);
  } else {
    console.log(
      `Starting with split algolia applications. Main ${ALGOLIA_APPLICATION_ID_1}, sorted: ${ALGOLIA_APPLICATION_ID_2}`,
    );
  }
}

export function getAlgoliaClient(index: AlgoliaIndiceName) {
  return (
    {
      [AlgoliaIndiceName.PRODUCTS_PRICE_ASC]: algoliaClient2,
      [AlgoliaIndiceName.PRODUCTS_PRICE_DESC]: algoliaClient2,
    }[index] || algoliaClient1
  );
}

export const algoliaSearchBase = createSearchBase(getAlgoliaClient);

export const getExcludedPartnersFilter = async () => {
  const response = await excludedPartnersSearch(algoliaSearchBase);
  const data = response.hits.map((hit) => `partner.id:${hit.objectID}`).join(' AND NOT ');
  return data;
};
